import { Action, PageStatus } from 'corso-admin-ui';

export function MediaDownloadPrompt({
  src,
  alt,
}: {
  src: string;
  alt: string;
}) {
  return (
    <PageStatus
      title="File Preview Unavailable"
      detail="This file type cannot be previewed at this time."
      icon="file"
      className="text-white"
    >
      <Action
        to={src}
        target="_blank"
        variant="primary"
        className="w-full"
        download
      >
        {`Download ${alt}`}
      </Action>
    </PageStatus>
  );
}
